/**
 * Template Engine constants — shared values referenced across the engine
 * and its parsers/importer. Phase 0 carries only what Phase 0 needs;
 * later phases (parser stages, variable tokens) extend this file, they
 * do not replace it.
 */

/** Bumped when the shape of an imported template document changes. */
export const IMPORT_VERSION = 1;

/** Where an incoming template document originated from. */
export const SOURCES = {
  AI_GENERATED: 'ai_generated',
  IMPORTED: 'imported',
};

/**
 * Placeholder tokens the import screen knows how to label.
 *
 * A token outside this list is still extracted — rejecting a name the author
 * invented would make the feature feel arbitrary — but it earns a warning, so
 * a typo like {{TITEL}} is visible rather than silently becoming its own field.
 */
export const VARIABLE_TOKENS = [
  'TITLE', 'SUBTITLE', 'DESCRIPTION',
  'PHONE', 'EMAIL', 'WEBSITE',
  'PRICE', 'ADDRESS',
  'IMAGE1', 'IMAGE2', 'IMAGE3',
  'LOGO', 'BUTTON', 'CTA',
];

/**
 * Stage names passed to `context.onProgress(stage, fraction)`.
 *
 * Shared rather than written inline at each call site: when parsing moves into
 * a Web Worker, the stage a progress event refers to has to survive the
 * postMessage boundary, and a typo in a string literal would surface only as a
 * progress bar that never moves.
 */
export const PARSE_STAGES = {
  NORMALIZE_INPUT: 'normalize-input',
  SELECT_PARSER: 'select-parser',
  PARSE: 'parse',
  NORMALIZE_DOCUMENT: 'normalize-document',
  VALIDATE: 'validate',
  DERIVE: 'derive',
  ASSEMBLE: 'assemble',
};
